/* eslint-disable no-bitwise */
import React, { Component } from 'react'
import { List } from 'immutable'
import PropTypes from 'prop-types'
import compose from 'recompose/compose'
import { connect as connectRedux } from 'react-redux'
import Link from '../Link/index'
import Button, { TYPES } from '../Button/index'
import { connect as connectStaticText } from '../StaticText/connect'
import {
  URL_ACCOUNT,
  URL_REFER,
  URL_ACCOUNT_SETTINGS,
  URL_ACCOUNT_PROFILE,
  HASHTAG_FOLLOW_SETTINGS,
} from '../../services/url/constants'
import IconV2, { ICON_TYPES } from '../Icon.v2/index'
import { NOTIFICATIONS_MANAGE_CLICKED_GA4_EVENT } from '../../services/event-tracking/index'

export const ACCOUNT = 'account'
export const NOTIFICATIONS = 'notifications'

function getNotificationsManageClickedEventData (location) {
  return NOTIFICATIONS_MANAGE_CLICKED_GA4_EVENT
    .mergeDeep({
      ui_element: 'Notification',
      ui_location: 'All Notifications',
      current_location: location.pathname,
      page_path: URL_ACCOUNT_SETTINGS + HASHTAG_FOLLOW_SETTINGS,
    })
}

function getNavByType (navType, staticText, location) {
  let navItems = []

  switch (navType) {
    case ACCOUNT: {
      navItems = [
        { url: URL_ACCOUNT, text: staticText.getIn(['data', 'account']) },
      ]
      navItems.push({ url: URL_ACCOUNT_PROFILE, text: staticText.getIn(['data', 'profile']) })
      navItems.push(
        { url: URL_ACCOUNT_SETTINGS, text: staticText.getIn(['data', 'settingsAndPreferences']) },
        { url: URL_REFER, text: staticText.getIn(['data', 'inviteAFriend']) },
      )
      break
    }
    case NOTIFICATIONS:
      navItems = [
        { url: '/notifications', text: staticText.getIn(['data', 'allNotifications']) },
        { url: URL_ACCOUNT_SETTINGS + HASHTAG_FOLLOW_SETTINGS, text: staticText.getIn(['data', 'manageNotifications']), ga4EventData: getNotificationsManageClickedEventData(location) },
      ]
      break
    default:
      break
  }
  return navItems
}

function navLinkClass (isActive) {
  const base = 'vertical-nav__link'
  const activeClass = `${base}--active`
  let className = List([base])
  if (isActive) {
    className = className.push(activeClass)
  }
  return className.join(' ')
}

class VerticalNav extends Component {
  //
  constructor (props) {
    super(props)
    this.state = {
      drawerOpen: false,
      width: 0,
    }
  }

  componentDidMount () {
    window.addEventListener('resize', this.handleWindowSizeChange)
    this.setState(() => ({ // eslint-disable-line
      width: window.innerWidth,
      drawerOpen: false,
    }))
  }

  componentWillUnmount () {
    window.removeEventListener('resize', this.handleWindowSizeChange)
  }

  setDrawerOpen = () => {
    this.setState({
      drawerOpen: !this.state.drawerOpen,
    })
  }

  handleWindowSizeChange = () => {
    const { state } = this
    const drawerOpen = state.drawerOpen && window.innerWidth < 720
    this.setState({
      width: window.innerWidth,
      drawerOpen,
    })
  }

  hideContentTooltipOnClick = () => {
    this.setState({ showHideContentTooltip: false })
  }

  renderMobile = () => {
    const { props, state } = this
    const { drawerOpen } = state
    const { navType, staticText, location } = props
    const navigationItems = getNavByType(navType, staticText, location)
    const activeItem = navigationItems.find((item) => item.url === location.pathname)

    return (
      drawerOpen
        ? <div className="vertical-nav" onClick={this.setDrawerOpen}>
          <IconV2
            className="vertical-nav__icon"
            type={ICON_TYPES.CHEVRON_UP}
          />
          {navigationItems.map((item) => {
            const isActive = item.url === activeItem.url
            return (
              isActive
                ? <Button
                  key={`${item.url}`}
                  type={TYPES.LINK}
                  onClick={this.setDrawerOpen}
                  className={`vertical-nav__link--mobile${isActive ? '-active' : ''}`}
                  ga4EventData={item.ga4EventData}
                >
                  {item.text}
                </Button>
                : <Link
                  key={`${item.url}`}
                  className={`vertical-nav__link--mobile${isActive ? '-active' : ''}`}
                  to={item.url}
                  onClick={this.setDrawerOpen}
                  ga4EventData={item.ga4EventData}
                >
                  {item.text}
                </Link>
            )
          })
          }
        </div>
        : <div onClick={this.setDrawerOpen} className="vertical-nav">
          <IconV2
            className="vertical-nav__icon"
            type={ICON_TYPES.CHEVRON_DOWN}
          />
          <div className="vertical-nav__link--mobile-active-no-hover">
            {activeItem ? activeItem.text : ''}
          </div>
        </div>
    )
  }

  renderDesktop = () => {
    const { props } = this
    const { navType, staticText, location } = props
    const navigationItems = getNavByType(navType, staticText, location)
    const renderedItems = navigationItems.map((item) => {
      const isActive = item.url === location.pathname
      return (
        <Link
          key={`${item.url}`}
          className={navLinkClass(isActive)}
          to={item.url}
          ga4EventData={item.ga4EventData}
        >
          {item.text}
        </Link>
      )
    })
    return (
      <nav className="vertical-nav">
        {renderedItems}
      </nav>
    )
  }

  render () {
    const { state } = this
    const { width } = state
    const isMobile = width < 944

    return (
      <div>{
        isMobile
          ? this.renderMobile()
          : this.renderDesktop()}</div>
    )
  }
}

VerticalNav.propTypes = {
  navType: PropTypes.string.isRequired,
  location: PropTypes.object.isRequired,
}

export default compose(
  connectRedux(
    (state) => {
      return {
        resolver: state.resolver,
        featureTracking: state.featureTracking,
        userStore: state.user,
      }
    },
  ),
  connectStaticText({ storeKey: 'verticalNavigation' }),
)(VerticalNav)
